import AuthTokenDashboard from './AuthTokenDashboard'

export default AuthTokenDashboard
